import { Visibility } from "@mui/icons-material";
import { Button, Card, Grid, Typography } from "@mui/material";
import React, { useState } from "react";

function TicketAttachments({ ticketValue }) {
    const [showCount, setShowCount] = useState(0);
    const handleChangeCount = (count) => {
        if (showCount === count) {
            setShowCount(0);
        } else {
            setShowCount(count);
        }
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={12} sx={12}>
                    <Button
                        onClick={(e) => handleChangeCount(1)}
                        fullWidth
                        variant="outlined"
                        startIcon={<Visibility />}
                    >
                        Solution
                    </Button>
                    {showCount === 1 && (
                        <Card style={{ marginTop: "10px" }}>
                            <embed
                                src={ticketValue?.opportunity?.pdf_path}
                                style={{ width: "100%", height: "90vh" }}
                            />
                        </Card>
                    )}
                </Grid>
                <Grid item md={12} sx={12}>
                    <Button
                        onClick={(e) => handleChangeCount(2)}
                        fullWidth
                        variant="outlined"
                        startIcon={<Visibility />}
                    >
                        Contract
                    </Button>
                    {showCount === 2 && (
                        <Card style={{ marginTop: "10px" }}>
                            <embed
                                src={'https://crm.boxbyld.tech/profiles/' + ticketValue?.contract?.eversign_document?.url}
                                style={{ width: "100%", height: "90vh" }}
                            />
                        </Card>
                    )}
                </Grid>
            </Grid>
        </>
    );
}

export default TicketAttachments;
